module.exports = __webpack_public_path__ + "img/teacher-title.a0cf9bb7.png";